import _classCallCheck from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _get from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/get";
import _inherits from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/inherits";

/**
 * @module ol/TileCache
 */
import LRUCache from './structs/LRUCache.js';
import { fromKey, getKey } from './tilecoord.js';

var TileCache =
/*#__PURE__*/
function (_LRUCache) {
  _inherits(TileCache, _LRUCache);

  function TileCache() {
    _classCallCheck(this, TileCache);

    return _possibleConstructorReturn(this, _getPrototypeOf(TileCache).apply(this, arguments));
  }

  _createClass(TileCache, [{
    key: "clear",
    value: function clear() {
      while (this.getCount() > 0) {
        this.pop().release();
      }

      _get(_getPrototypeOf(TileCache.prototype), "clear", this).call(this);
    }
    /**
     * @param {!Object<string, boolean>} usedTiles Used tiles.
     */

  }, {
    key: "expireCache",
    value: function expireCache(usedTiles) {
      while (this.canExpireCache()) {
        var tile = this.peekLast();

        if (tile.getKey() in usedTiles) {
          break;
        } else {
          this.pop().release();
        }
      }
    }
    /**
     * Prune all tiles from the cache that don't have the same z as the newest tile.
     */

  }, {
    key: "pruneExceptNewestZ",
    value: function pruneExceptNewestZ() {
      if (this.getCount() === 0) {
        return;
      }

      var key = this.peekFirstKey();
      var tileCoord = fromKey(key);
      var z = tileCoord[0];
      this.forEach(function (tile) {
        if (tile.tileCoord[0] !== z) {
          this.remove(getKey(tile.tileCoord));
          tile.release();
        }
      }.bind(this));
    }
  }]);

  return TileCache;
}(LRUCache);

export default TileCache;